import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    title: "广州苍木信息科技有限公司",
    isShowFooter: false,
    seq: "1"
  },
  mutations: {
    changeFooterStatus(state, status) {
      state.isShowFooter = status;
    }
  },
  actions: {}
});
